<bit-banner variant="warning" (dismiss)="onDismiss.emit()">
  {{ "verifyEmailDesc" | i18n }}
  <button
    id="sendBtn"
    bitLink
    linkType="secondary"
    type="button"
    buttonType="unstyled"
    (click)="send()"
  >
    {{ "sendEmail" | i18n }}
  </button>
</bit-banner>
